import { Component, EventEmitter, Output, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

export enum CategoryTypeEnum {
  BASIC = "basic",
  STANDARD = "standard",
  PREMIUM = "premium"
}
export enum UserStatusEnum {
  ACTIVE = "active",
  INACTIVE = "inactive",
  SUSPENDED = "suspended"
}
export enum PaymentModeEnum {
  CHEQUE = "cheque",
  CASH = "cash",
  DIGITAL = "digital"
}
export enum KycStatusEnum {
  COMPLETED = "completed",
  REJECTED = "rejected",
  PENDING = "pending"
}

@Component({
  selector: 'app-add-retailer-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './add-retailer-modal.component.html',
  styleUrls: ['./add-retailer-modal.component.scss']
})
export class AddRetailerModalComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  @Output() submitRetailer = new EventEmitter<any>();
  @Input() isEdit: boolean = false;
  @Input() retailer: any = {
    retailer_name: '',
    email: '',
    phone_number: '',
    alt_phone_number: null,
    gst: '',
    pan: '',
    purchase_limit: '',
    retailer_agency: '',
    address_line1: '',
    address_line2: '',
    pincode: '',
    state: '',
    city: '',
    status: UserStatusEnum.ACTIVE,
    preferred_payment_mode: PaymentModeEnum.CASH,
    kyc_status: KycStatusEnum.PENDING,
    category: CategoryTypeEnum.BASIC,
  };

  categoryTypes = Object.values(CategoryTypeEnum);
  userStatuses = Object.values(UserStatusEnum);
  paymentModes = Object.values(PaymentModeEnum);
  kycStatuses = Object.values(KycStatusEnum);


  submitting = false;
  errorMsg = '';
  fieldErrors: { [key: string]: string } = {};

  pinLocationVerified = false;

  onPincodeChange(pincode: string) {
    if (pincode && pincode.toString().trim().length === 6) {
      this.http.get<any>(`https://api.postalpincode.in/pincode/${pincode.toString().trim()}`).subscribe({
        next: (res) => {
          if (res && res[0] && res[0].Status === 'Success' && res[0].PostOffice && res[0].PostOffice.length > 0) {
            const postOffice = res[0].PostOffice[0];
            // District is usually the primary city level name
            this.retailer.city = postOffice.District || postOffice.Block;
            this.retailer.state = postOffice.State;
            this.pinLocationVerified = true;
          } else {
            this.pinLocationVerified = false;
          }
        },
        error: () => {
          this.pinLocationVerified = false;
        }
      });
    } else {
      this.pinLocationVerified = false;
    }
  }

  constructor(private http: HttpClient) { }

  ngOnInit() {
    if (!this.retailer) {
      this.retailer = {
        retailer_name: '',
        email: '',
        phone_number: '',
        alt_phone_number: null,
        gst: '',
        pan: '',
        purchase_limit: '',
        retailer_agency: '',
        address_line1: '',
        address_line2: '',
        pincode: '',
        state: '',
        city: '',
        status: UserStatusEnum.ACTIVE,
        preferred_payment_mode: PaymentModeEnum.CASH,
        kyc_status: KycStatusEnum.PENDING,
        category: CategoryTypeEnum.BASIC,
      };
    }
  }


  selectDistributor(distributor: any) {
    // Kept for backward compatibility but no longer used in template
  }

  validate() {
    this.fieldErrors = {};
    // Retailer Name
    if (!this.retailer.retailer_name) {
      this.fieldErrors['retailer_name'] = 'Retailer Name is required.';
    }
    // Status - removed validation, will use default
    // Email
    if (!this.retailer.email) {
      this.fieldErrors['email'] = 'Email is required.';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.retailer.email)) {
      this.fieldErrors['email'] = 'Invalid email format.';
    }
    // Phone Number
    if (!this.retailer.phone_number) {
      this.fieldErrors['phone_number'] = 'Phone Number is required.';
    } else if (!/^\d{10,}$/.test(String(this.retailer.phone_number))) {
      this.fieldErrors['phone_number'] = 'Invalid phone number.';
    }
    // Alt Phone Number (optional)
    if (this.retailer.alt_phone_number && !/^\d{10,}$/.test(String(this.retailer.alt_phone_number))) {
      this.fieldErrors['alt_phone_number'] = 'Invalid alternate phone number.';
    }
    // PAN
    if (!this.retailer.pan) {
      this.fieldErrors['pan'] = 'PAN Number is required.';
    }
    // Purchase Limit
    if (!this.retailer.purchase_limit) {
      this.fieldErrors['purchase_limit'] = 'Purchase Limit is required.';
    }
    // Address Line 1
    if (!this.retailer.address_line1) {
      this.fieldErrors['address_line1'] = 'Address Line 1 is required.';
    }
    // Pincode
    if (!this.retailer.pincode) {
      this.fieldErrors['pincode'] = 'Pincode is required.';
    } else if (!/^\d{6}$/.test(String(this.retailer.pincode))) {
      this.fieldErrors['pincode'] = 'Invalid pincode.';
    }
    // State
    if (!this.retailer.state) {
      this.fieldErrors['state'] = 'State is required.';
    }
    // City
    if (!this.retailer.city) {
      this.fieldErrors['city'] = 'City is required.';
    }
    // Payment Mode - removed validation, will use default value
    // KYC Status - removed validation, will use default
    // Category - removed validation, will use default
    return Object.keys(this.fieldErrors).length === 0;
  }

  onSubmit() {
    this.errorMsg = '';
    if (!this.validate()) {
      this.errorMsg = 'Please fix the errors above.';
      return;
    }
    this.submitting = true;
    // preferred_payment_mode will be sent with default value (CASH)
    this.submitRetailer.emit(this.retailer);
  }

  resetSubmitting() {
    this.submitting = false;
  }

  onClose() {
    this.close.emit();
  }
}
